module.exports = __webpack_public_path__ + "img/banner-3.72cafe69.jpg";